// extracted by mini-css-extract-plugin
export default {"buttonBack":"styles_buttonBack__OJZZi","buttonNext":"styles_buttonNext__c97+F"};